/**
 * Summary Amount info
 */
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { formatMoney } from 'src/utils/utility';

interface IAmountInfoContainerProps extends PropsWithChildren {
  isLast?: boolean;
  isTotal?: boolean;
  className?: string;
}

interface IAmountInfoSubContainerProps {
  title: string;
  isCredit?: boolean;
  taxValue: number;
  currency?: string;
}

interface IAmountInfo {
  isLast?: boolean;
  title: string;
  total: number;
  beforeTaxValue?: number;
  currency?: string;
  className?: string;
  isCredit?: boolean;
  isTotal?: boolean;
}

const AmountInfoContainer: React.FC<IAmountInfoContainerProps> = ({ isLast, isTotal, className, children }) => (
  <div
    className={clsx(
      'flex flex-col items-center gap-16',
      !isLast && 'mb-10 xl:mb-12',
      isTotal && 'pt-10 xl:pt-12 mt-10 xl:mt-12 border-t border-neutral-40',
      className
    )}
  >
    {children}
  </div>
);

const AmountInfoSub: React.FC<IAmountInfoSubContainerProps> = ({ title, isCredit, currency, taxValue }) => (
  <div className='flex items-center gap-4 w-full'>
    <div className='w-1/2 text-10 xl:text-12 text-blue_grey-30'>{title}</div>
    <div className={clsx('w-1/2 text-10 xl:text-12 font-medium text-right', isCredit ? 'text-red-40' : 'text-black')}>{formatMoney(taxValue, currency)}</div>
  </div>
);

const AmountInfo = (props: IAmountInfo) => {
  const { title, total, beforeTaxValue, isCredit, isLast, isTotal, currency, className } = props;

  return (
    <AmountInfoContainer isLast={isLast} isTotal={isTotal} className={className}>
      <div className='flex items-center gap-4 w-full'>
        <div className='w-1/2 text-12 xl:text-14 text-blue_grey-30'>{title}</div>
        {total !== null && (
          <div className={clsx('w-1/2 text-14 xl:text-16 font-bold text-right', isCredit ? 'text-red-40' : 'text-black')}>{formatMoney(total, currency)}</div>
        )}
      </div>
      {beforeTaxValue && <AmountInfoSub title='Before Tax' isCredit={isCredit} taxValue={beforeTaxValue} currency={currency} />}
    </AmountInfoContainer>
  );
};

AmountInfo.Sub = AmountInfoSub;
AmountInfo.Container = AmountInfoContainer;

export { AmountInfo };
